// extracted by mini-css-extract-plugin
export default {"hidden":"Layout_hidden__mEZtI","monospace":"Layout_monospace__ZhcUD","wFull":"Layout_wFull__GdLbz","ellipsis":"Layout_ellipsis__CYXTM","container":"Layout_container__3lZO0"};